import { Component, Input } from '@angular/core';
import { GridCell, RowCell } from '@urbannex/storethemes';
import { ImageEditorComponent } from '../../../section-builder-editors/image-editor/image-editor.component';
import { BaseCellStepper } from '../../model';
import { NbDialogService } from '@nebular/theme';
import { ConfigurationService } from '@urbannex/configuration';
import { OfbizFormsService } from '@urbannex/ofbiz-forms';
import { SectionBuilderStoreService } from '../../../section-builder-store.service';

@Component({
  selector: 'kve-image-step',
  templateUrl: './image-step.component.html',
  styleUrls: ['./image-step.component.scss']
})
export class ImageStepComponent extends BaseCellStepper{
  @Input() cell:RowCell | GridCell

  constructor(
    dialogService:NbDialogService,
    ofbizFormsService:OfbizFormsService,
    sectionBuilderStoreService:SectionBuilderStoreService,
    configurationService:ConfigurationService){
    super(dialogService,ofbizFormsService,sectionBuilderStoreService,configurationService)
  }

  /* imageDialog(){
    this.dialogService.open(ImageEditorComponent, {
      context: {
        title: 'Gallery',
        section:this.section,
        //cellId:this.cell.cellId
      },
    }).onClose.subscribe(() => {
      this.sectionBuilderStoreService.selectedCell$.subscribe(data => {
        console.log(data);
        this.imgSrc = data.imgSrc;
        this.showPlaceholder = false;
      });
    })
  }

  onImageError() {
    this.showPlaceholder = true;
  } */
}
